import styled from 'styled-components'

export const ProgressBarContainer = styled.div`
  position: relative;
  width: 100%;
  height: 40px;
  background: #EBEBEB;
  overflow: hidden;
`

export const ProgressBarFill = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: ${props => (props.value / props.total) * 100}%;
  background: ${props => {
    switch(props.status) {
      case 'active':
        return '#7BC586';
      case 'trial':
        return '#7BC586';
      case 'expired':
      case 'trial-expired':
        return '#CCCCCC';
      case 'expiring-soon':
      case 'trial-expiring':
        return '#FFB37C';
      default:
        return '#CCCCCC';
    }
  }};
`

export const ProgressContent = styled.div`
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 16px;
  justify-content: space-between;
  font-size: 14px;
`

export const StatusBadge = styled.span`
  background: #FFFFFF;
  border-radius: 6px;
  padding: 4px 10px;
  font-weight: 500;
  font-size: 13px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  color: ${props => {
    switch(props.status) {
      case 'active':
        return '#52c41a';
      case 'trial':
        return '#52c41a';
      case 'expired':
      case 'trial-expired':
        return '#8C8C8C';
      case 'expiring-soon':
      case 'trial-expiring':
        return '#FA8C16';
      default:
        return '#8C8C8C';
    }
  }};
`

export const UsageText = styled.span`
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
`
